import type { PlaycastMessage, PlaycastMessageTarget } from '@playcastdotio/Messaging';

export const GAME_SAVE_REPLY_CHANNEL = 'game-save:reply';
export interface IGameSaveReplyChannel {
  isAvailable(): boolean;
  subscribeGameSaveReplies(listener: (message: unknown) => void): () => void;
}
interface RendererMessageBridge {
  on(channel: string, callback: (message: PlaycastMessage<PlaycastMessageTarget>) => void): void;
}

/** Uses the existing preload's generic IPC channel; it never replaces the app's mainMessage handler. */
export class GameSaveReplyChannel implements IGameSaveReplyChannel {
  private readonly listeners = new Set<(message: unknown) => void>();
  constructor(private readonly bridge?: RendererMessageBridge) {
    bridge?.on(GAME_SAVE_REPLY_CHANNEL, (message) => {
      for (const listener of this.listeners) listener(message);
    });
  }
  isAvailable(): boolean { return Boolean(this.bridge); }
  subscribeGameSaveReplies(listener: (message: unknown) => void): () => void {
    this.listeners.add(listener);
    return () => { this.listeners.delete(listener); };
  }
}
